// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddCaseTagPopup_add_tag_container__G5kV\\+ {
  display: flex;
  justify-content: space-between;
  max-height: 100%;
  overflow: scroll;
}

.AddCaseTagPopup_autocomplete_container__\\+zFvr {
  width: 55%;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/AddCaseTagPopup/AddCaseTagPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".add_tag_container {\n  display: flex;\n  justify-content: space-between;\n  max-height: 100%;\n  overflow: scroll;\n}\n\n.autocomplete_container {\n  width: 55%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add_tag_container": `AddCaseTagPopup_add_tag_container__G5kV+`,
	"autocomplete_container": `AddCaseTagPopup_autocomplete_container__+zFvr`
};
export default ___CSS_LOADER_EXPORT___;
